import React from "react";

const DocxContext = React.createContext(null);

export default DocxContext;
